var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-scroll-y-transition', {
    staticClass: "transition-wrapper",
    "class": {
      'success-banner': _vm.interactiveMessage
    },
    attrs: {
      "tag": "div",
      "group": ""
    }
  }, [_vm._l(_vm.messages, function (message, key) {
    return _c('div', {
      key: key,
      staticClass: "notification-success-message"
    }, [message.type !== 'confirmation' ? _c('div', {
      staticClass: "success-message",
      "class": _vm.getClass(message.type)
    }, [_c('img', {
      staticClass: "image-4 noselect",
      attrs: {
        "src": _vm.getImage(message.type),
        "loading": "lazy",
        "alt": "",
        "width": "40",
        "height": "40"
      }
    }), _c('div', {
      staticClass: "noselect"
    }, [_vm._v(_vm._s(message.text))])]) : _vm._e()]);
  }), _vm.interactiveMessage ? _c('div', {
    key: "1",
    staticClass: "notification-success-message",
    staticStyle: {
      "padding-right": "20px"
    }
  }, [_c('div', {
    staticClass: "success-message confirmation-background"
  }, [_c('div', {
    staticClass: "noselect ml-3 mr-5"
  }, [_vm._v(_vm._s(_vm.interactiveMessage.text))]), _c('div', {
    staticClass: "d-flex flex-row align-items-center"
  }, [_c('button', {
    staticClass: "confirmation-button mr-2",
    on: {
      "click": function click($event) {
        _vm.callbackPass = true;
      }
    }
  }, [_vm._v(" OK ")]), _c('img', {
    staticClass: "pointer",
    attrs: {
      "src": require("@/images/x.png"),
      "alt": "",
      "width": "13",
      "height": "13"
    },
    on: {
      "click": function click($event) {
        _vm.callbackPass = false;
      }
    }
  })])])]) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }